<mf-page title="Cargar comprobante">
  <mf-collect-order-voucher
    [transferVoucherForCollectOrderDto]="transferVoucherForCollectOrderDto"
    [personId]="personId"
    (save)="submit($event)" />
</mf-page>
